import {
  HttpErrorResponse, HttpHandler,
  HttpInterceptor,
  HttpRequest
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { AppService } from "src/app/app.service";
import { ENVIRONMENT } from "src/app/shared/constant/constant";
import { CrossStorageService } from "src/app/shared/service/cross-storage/cross-storage.service";
import { UserService } from "src/app/shared/service/user/user.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	private readonly JWT_TOKEN = "JWT_TOKEN";
	private readonly USER_ID = "USER_ID";

  constructor(
    private userService: UserService,
    private crossStorage: CrossStorageService,
    private appService: AppService
  ) {}

	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
  ): any {
    if (this.getJwtToken()) {
      request = this.addToken(request, this.getJwtToken());
    }

		return next.handle(request).pipe(
			catchError((error) => {
				if (
					error instanceof HttpErrorResponse &&
					error.status === 401
				) {
					this.handle401Error(request, next);
				} else {
					return throwError(error);
				}
			})
		);
	}

	getJwtToken() {
		return localStorage.getItem(this.JWT_TOKEN);
	}

  private addToken(request: HttpRequest<any>, token: string) {
		if (request.url.includes("auth")) {
			return request.clone({
				setHeaders: {
					Authorization: `Bearer ${token}`,
				},
			});
    } else {
      const subdomain = this.appService.getCurrentSubDomain()
      this.appService.getEnvironmentName(subdomain);
			return request.clone({
				setHeaders: {
					Authorization: `Bearer ${token}`,
          userId: this.userService.getUserNo(),
          client: this.crossStorage.getSubdomain(),
          env: localStorage.getItem(ENVIRONMENT),
				},
			});
		}
	}

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    // TODO using cross storage if auth is logged in
    // * if yes the refresh token and recall request to maintain momentum of application
    // * else redirect to auth
    console.log(request)
  }
}
